import React from "react";
import thinking from "../../../../../../../../images/how-it-work/thinking-desktop.png"
export default function YesNoThinking() {
  return (
    <div className="diet-programs-left-section-inner"><img src={thinking}></img></div> 
  );
}
